// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import Global from '@/api/global'
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)
Vue.prototype.cookie = VueCookie
Vue.prototype.$axios = axios
Vue.use(ElementUI)
Vue.use(VXETable)

Vue.prototype.$global = Global
Vue.config.productionTip = false
axios.defaults.baseURL = 'http://localhost:8080' // 此处是https协议如果不是改成http
// 给axios添加请求拦截器
axios.defaults.retry = 3
axios.defaults.retryDelay = 1000
axios.interceptors.request.use(
  //  function (config) {
  config => {
    // Do something before request is sent
    if (localStorage.getItem('token')) {
      // 如果令牌存在 将令牌添加到请求头部中 key值为LINGPAI
      config.headers.token = localStorage.getItem('token')
      config.headers.userId = localStorage.getItem('userId')
    } else {
      console.log('token null')
    }
    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js